import { motion } from "framer-motion";
import { useI18n, pick } from "@/lib/i18n";
import { useContent } from "@/lib/content";

export default function Process() {
  const { lang } = useI18n();
  const { content } = useContent();
  const p = content?.process;
  if (!p) return null;
  const header = pick(p, lang, p.ru);
  const steps = p.steps || [];
  return (
    <section id="process" className="py-16 sm:py-20 lg:py-32" data-testid="process-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-10 sm:mb-12 lg:mb-16">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent/10 text-accent text-xs font-semibold mb-4">
            {lang === "ru" ? "Процесс" : "Process"}
          </div>
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-5xl font-semibold tracking-tight">{header.title}</h2>
          <p className="mt-4 text-base text-muted-foreground">{header.subtitle}</p>
        </div>
        <div className="relative grid md:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
          <div className="absolute top-10 left-0 right-0 h-px bg-gradient-to-r from-transparent via-border to-transparent hidden lg:block" />
          {steps.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="relative p-5 sm:p-6 lg:p-8 rounded-2xl border border-border bg-card"
              data-testid={`process-step-${i}`}
            >
              <div className="relative size-12 mb-5 mx-auto lg:mx-0">
                <div className="absolute inset-0 rounded-full bg-foreground text-background flex items-center justify-center font-mono text-lg font-bold">
                  {i + 1}
                </div>
                <div className="absolute -inset-1 rounded-full border border-accent/30 animate-pulse-glow" />
              </div>
              <h3 className="font-heading text-lg font-semibold mb-2">
                {lang === "ru" ? s.ru_title : s.en_title}
              </h3>
              <p className="text-sm text-muted-foreground">
                {lang === "ru" ? s.ru_text : s.en_text}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
